import Vue from 'vue';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { dateOnlyFormat, dateTimeFormat } from './utils/date';
import countryToCurrency from 'country-to-currency';

Vue.filter('limitLength', function(value, length = 100) {
  let tmp = value.substring(0, length);
  if (value.length > length) {
    tmp += '...';
  }
  return tmp;
});

Vue.filter('escapeHtml', function(value) {
  if (!value) {
    return '';
  }
  return value.replace(/<\/?[^>]+(>|$)/g, '');
});

Vue.filter('addressMediaFile', function(value) {
  return (
    'https://' + value.bucket + '.' + value.endpoint + '/' + value.oss_object
  );
});

Vue.filter('internationalPhoneNumber', function(value) {
  if (!value) {
    return '';
  }
  const phoneObject = parsePhoneNumberFromString(value);
  if (!phoneObject || !phoneObject.isValid()) {
    return value;
  }
  return phoneObject.formatInternational();
});

Vue.filter('dollar', function(num, countryCode = 'AU') {
  const formatter = new Intl.NumberFormat('en-' + countryCode, {
    style: 'currency',
    currency: countryToCurrency[countryCode],
    minimumFractionDigits: 2,
  });
  if (countryCode == 'AU') {
    return 'AU ' + formatter.format(num / 100);
  }

  if (countryCode == 'NZ') {
    return 'NZ ' + formatter.format(num / 100);
  }

  return formatter.format(num / 100);
});

Vue.filter('currencySymbol', function(countryCode = 'AU') {
  const formatter = new Intl.NumberFormat('en-' + countryCode, {
    style: 'currency',
    currency: countryToCurrency[countryCode],
  });

  return (
    countryCode +
      ' ' +
      formatter.formatToParts(1).find((x) => x.type === 'currency')?.value ||
    '$'
  );
});

Vue.filter('dateOnly', dateOnlyFormat);

Vue.filter('statusColour', (key, statuses) => {
  if (!(key in statuses)) {
    return statuses.STATUS_DEFAULT.color;
  }
  return statuses[key].color;
});

Vue.filter('statusText', (key, statuses) => {
  if (!(key in statuses)) {
    return statuses.STATUS_DEFAULT.value;
  }
  return statuses[key].value;
});

Vue.filter('methodColour', (key, methods) => {
  return methods[key].color;
});

Vue.filter('methodText', (key, methods) => {
  return methods[key].value;
});

Vue.filter('candidateName', function(item, index) {
  const arr = [item.first_name ?? null, item.last_name ?? null];

  const candidateName = arr.filter(Boolean).join(' ');

  if (candidateName.length == 0) {
    return `Candidate ${index + 1}`;
  }

  return candidateName;
});

Vue.filter('candidateContact', function(item) {
  let email = item.email;
  let mobile = item.mobile;
  if (item.is_email_valid === false) {
    email = "<span class='error--text'>" + item.email + '</span';
  }
  if (item.is_mobile_valid === false) {
    mobile = "<span class='error--text'>" + item.mobile + '</span';
  }
  const arr = [email ?? null, mobile ?? null];

  return arr.filter(Boolean).join(', ');
});

Vue.filter('date', dateTimeFormat);

Vue.filter('riskProfileGidAndName', (riskProfile) => {
  const { name, gid } = riskProfile;
  let displayName = '';
  if (gid) {
    displayName +=
      'ID: ' +
      gid.substring(0, 6) +
      '-' +
      gid.substring(6, 8) +
      '-' +
      gid.substring(8);
  }
  if (name != gid) {
    displayName += ' ' + name;
  }
  return displayName;
});

Vue.filter('numberFormat', (value: number, digits = 2) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
});
